import Model from './Model'
import ExpenseItem from './ExpenseItem'
export default class Expense extends Model {

    resource()
    {
        return 'expenses'
    }

    items() {
        return this.hasMany(ExpenseItem)
    }
}
